import { render, staticRenderFns } from "./ItemAuthorActionItem.vue?vue&type=template&id=d431eb16"
import script from "./ItemAuthorActionItem.vue?vue&type=script&lang=ts"
export * from "./ItemAuthorActionItem.vue?vue&type=script&lang=ts"
import style0 from "./ItemAuthorActionItem.vue?vue&type=style&index=0&id=d431eb16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports